const _ = require('underscore');
const API = require('jiji/infra/api/user');
const GoogleAccount = require('jiji/domain/entity/account/google');
const QuadceptAccount = require('jiji/domain/entity/account/quadcept');

class AccountFactory {
    static build(accountJson) {
        const kind = accountJson.kind;
        if (kind === 'GoogleAccount'){
            return new GoogleAccount(accountJson)
        }
        if (kind === 'QuadceptAccount') {
            return new QuadceptAccount(accountJson);
        }
    }
}

class Repository {
    getLoginUserAccounts() {
        return new Promise((resolve, reject) => {
            API.getAccounts()
                .then(accounts => {
                    resolve(_.map(accounts, AccountFactory.build));
                }, (reason) => {
                    const status = reason.status;
                    reject(status);
                });
        });
    }

    getUnconnectedAccounts() {
        return new Promise((resolve, reject) => {
            API.getUnconnectedAccounts()
                .then(accounts => {
                    resolve(_.map(accounts, AccountFactory.build));
                }, (reason) => {
                    const status = reason.status;
                    reject(status);
                });
        });
    }
}

module.exports = new Repository();



// WEBPACK FOOTER //
// ./jiji/domain/repository/account.js